import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { usersCollectionReducer } from './usersCollection/usersCollectionReducer';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { clientLenderContactsReducer } from './order/clientLenderContacts/clientLenderContactsReducer';
import { orderReducer } from './order/OrderReducer';
import { clientOrdersSearchReducer } from '../clientPortal/store/clientOrdersSearch/reducer';
import { countiesSlice } from './counties';
import { ordersSearchSlice } from './orders';
import { accountingReducer } from './accounting/store';
import { associatedLendersDataSlice } from './orderCreation/associatedLendersDataSlice';
import { pricingReducer } from './administration/pricing/PricingReducer';
import { conversationReducer } from './conversations/conversationsReducer';
import { environmentSlice } from './environment/environmentSlice';
import { vendorReducer } from 'store/vendorStore/vendorStore';
import { orderNavigationSlice } from './order/orderNavigation/orderNavigationSlice';
import { sideDrawerSlice } from './sideDrawer/sideDrawerSlice';
import { clientReducer } from './clientPortal/clientReducer';
import { redirectTargetSlice } from './authentication/redirectTargetSlice';
import { BaseAPI } from 'API/BaseApi';
import { LocalStorageAPI } from 'API/LocalStoreApi';

export const rootReducer = combineReducers({
  environmentSlice: environmentSlice.reducer,
  associatedLendersDataSlice: associatedLendersDataSlice.reducer,
  clientLenderContacts: clientLenderContactsReducer,
  usersCollection: usersCollectionReducer,
  order: orderReducer,
  clientOrdersSearch: clientOrdersSearchReducer.reducer,
  counties: countiesSlice.reducer,
  ordersSearch: ordersSearchSlice.reducer,
  accounting: accountingReducer,
  sideDrawer: sideDrawerSlice.reducer,
  conversations: conversationReducer,
  pricing: pricingReducer,
  vendorDashboard: vendorReducer,
  orderNavigationSlice: orderNavigationSlice.reducer,
  redirectTargetSlice: redirectTargetSlice.reducer,
  clientPortal: clientReducer,
  [BaseAPI.reducerPath]: BaseAPI.reducer,
  [LocalStorageAPI.reducerPath]: LocalStorageAPI.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(BaseAPI.middleware).concat(LocalStorageAPI.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
